import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ElevatorCovarage extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  thirdpartyPriceDiscState: this.props.elevatorDisc,
                  // selectedElevatorKinddoor : {
                  //       value: this.props.elevatorDisc.elevator_price_covarage_elevator_kinddoor_id,
                  //       label: this.props.elevatorDisc.elevator_kinddoor_name,
                  // },
                  selectedElevatorCoverage: {
                        value: this.props.elevatorDisc.elevator_price_coverage_elevator_coverage_id,
                        label: this.props.elevatorDisc.elevator_coverage_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  // optionElevatorKinddoor : [],
                  optionElevatorCoverage: [],
                  // elevator_price_coverage_from_person : "",
                  // elevator_price_coverage_to_person : ""

            }
      }
      componentDidMount() {
            this.getoptionElevatorKinddoor ()
            this.getoptionElevatorCoverage()
      }

      getoptionElevatorKinddoor  = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_kinddoor_id, label: arr.data[k].elevator_kinddoor_name })
                              }
                              self.setState({ optionElevatorKinddoor : Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_kinddoor")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }


      getoptionElevatorCoverage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].elevator_coverage_id, label: arr.data[k].elevator_coverage_name })
                              }
                              self.setState({ optionElevatorCoverage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_elevator_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }


      handleElevatorCoverage  = (selectedElevatorCoverage) => {
            var temparray = this.state.thirdpartyPriceDiscState
            console.log("*****************************");
            console.log(selectedElevatorCoverage.value);
            console.log("*****************************");
            temparray.elevator_price_covarage_elevator_covarage_id = selectedElevatorCoverage.value
            this.setState({ selectedElevatorCoverage: selectedElevatorCoverage, thirdpartyPriceDiscState: temparray })
      }

      handleElevatorFromPerson  = (event) => {
            var temparray = this.state.thirdpartyPriceDiscState
            temparray.elevator_price_from_person = event
            this.setState({ elevator_price_from_person: event, thirdpartyPriceDiscState: temparray })
      }
      handleElevatorToPerson  = (event) => {
            var temparray = this.state.thirdpartyPriceDiscState
            temparray.elevator_price_to_person = event
            this.setState({ elevator_price_to_person: event, thirdpartyPriceDiscState: temparray })
      }



      handleChangeCovaragePrice = (event) => {
            var temparray = this.state.thirdpartyPriceDiscState
            temparray.elevator_price_covarage_price = event
            this.setState({ thirdpartyPriceDiscState: temparray })
      }



      modifyNewInstalmentCondition = () => {
            const { thirdpartyPriceDiscState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            console.log(thirdpartyPriceDiscState);
            fd.append("command", "modify_price_covarage")
            fd.append("elevator_price_covarage_id", thirdpartyPriceDiscState.elevator_price_covarage_id)
            // fd.append("elevator_price_covarage_elevator_kinddoor_id", thirdpartyPriceDiscState.elevator_price_covarage_elevator_kinddoor_id)
            fd.append("elevator_price_covarage_elevator_covarage_id", thirdpartyPriceDiscState.elevator_price_covarage_elevator_covarage_id)
            fd.append("elevator_price_covarage_price", thirdpartyPriceDiscState.elevator_price_covarage_price)
            fd.append("elevator_price_covarage_from_person", thirdpartyPriceDiscState.elevator_price_from_person)
            fd.append("elevator_price_covarage_to_person", thirdpartyPriceDiscState.elevator_price_to_person)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { thirdpartyPriceDiscState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_covarage")
            fd.append("elevator_price_covarage_id", thirdpartyPriceDiscState.elevator_price_covarage_id)

            xhttp.open("POST", `${constants.BASE_URL}/elevator`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionElevatorCoverage,optionElevatorKinddoor , snackMode, snackstr, showSnack, visible, selectedElevatorKinddoor , selectedElevatorCoverage, thirdpartyPriceDiscState } = this.state
            // console.log("*************************")
            // console.log(thirdpartyPriceDiscState);
            // console.log("*************************")

            if (visible) {
                  return (
                      <Grid container spacing={3}>
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>

                            {/*<Grid item xs={3}>*/}
                            {/*      <div>*/}
                            {/*            <label className="on">پوشش بیمه نامه </label>*/}
                            {/*            <Select*/}
                            {/*                isSearchable={true}*/}
                            {/*                className="adapter-txtsize"*/}
                            {/*                placeholder={"پوشش بیمه نامه"}*/}
                            {/*                value={selectedElevatorCoverage}*/}
                            {/*                onChange={this.handleElevatorCoverage }*/}
                            {/*                options={optionElevatorCoverage}*/}
                            {/*            />*/}
                            {/*      </div>*/}
                            {/*</Grid>*/}

                            {/*<Grid item xs={3}>*/}
                            {/*      <div>*/}
                            {/*            <label className="on">نوع درب </label>*/}
                            {/*            <Select*/}
                            {/*                isSearchable={true}*/}
                            {/*                className="adapter-txtsize"*/}
                            {/*                placeholder={"نوع درب"}*/}
                            {/*                value={selectedElevatorKinddoor }*/}
                            {/*                onChange={this.handleElevatorKinddoor  }*/}
                            {/*                options={optionElevatorKinddoor }*/}
                            {/*            />*/}
                            {/*      </div>*/}
                            {/*</Grid>*/}



                            {/*<Grid item xs={3}>*/}
                            {/*      <FloatingLabelInput*/}
                            {/*          type="currency"*/}
                            {/*          placeholder=" قیمت بیمه نامه"*/}
                            {/*          handleInputt={this.handleChangeCovaragePrice}*/}
                            {/*          value={thirdpartyPriceDiscState.elevator_price_covarage_price}*/}
                            {/*      />*/}
                            {/*</Grid>*/}

                            <Grid item item xs={1}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder="از نفر "
                                      handleInputt={this.handleElevatorFromPerson}
                                      value={thirdpartyPriceDiscState.elevator_price_from_person}
                                  />
                            </Grid>
                            <Grid item item xs={1}>
                                  <FloatingLabelInput
                                      type="number"
                                      placeholder=" تا نفر "
                                      handleInputt={this.handleElevatorToPerson}
                                      value={thirdpartyPriceDiscState.elevator_price_to_person}
                                  />
                            </Grid>

                            <Grid item xs={3}>
                                  <div>
                                        <label className="on"> پوشش بیمه نامه </label>
                                        <Select
                                            isSearchable={true}
                                            className="adapter-txtsize"
                                            placeholder={" پوشش بیمه نامه"}
                                            value={selectedElevatorCoverage}
                                            onChange={this.handleElevatorCoverage}
                                            options={optionElevatorCoverage}
                                        />
                                  </div>
                            </Grid>



                            <Grid item item xs={3}>
                                  <FloatingLabelInput
                                      type="currency"
                                      placeholder=" قیمت بیمه نامه "
                                      handleInputt={this.handleChangeCovaragePrice}
                                      value={thirdpartyPriceDiscState.elevator_price_covarage_price}
                                  />
                            </Grid>

                            <Grid item xs={3}>
                                  <div style={{ width: "100%", textAlign: "left" }}>
                                        <Fab
                                            className={classes.small}
                                            style={{ background: "#44b700" }}
                                            aria-label="edit"
                                            onClick={this.modifyNewInstalmentCondition}
                                        >
                                              <EditIcon />
                                        </Fab>

                                        <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                              <DeleteIcon />
                                        </Fab>
                                  </div>
                            </Grid>
                            <Grid item xs={12}>
                                  <Divider />
                            </Grid>
                      </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ElevatorCovarage)
